import React, { useMemo, useState } from 'react';

const SURVEY_ICONS = [
    'clipboard-check',
    'clipboard2-pulse',
    'ui-checks',
    'list-check',
    'card-checklist',
    'journal-check',
    'file-earmark-text',
    'chat-square-heart',
    'emoji-smile',
    'hand-thumbs-up',
    'star',
    'heart',
    'award',
    'trophy',
    'person-hearts',
    'people',
    'hospital',
    'capsule',
    'eyeglasses',
    'eye',
    'calendar-check',
    'bell',
    'megaphone',
    'send',
    'envelope',
    'telephone',
    'geo-alt',
    'building',
    'house-heart',
    'shield-check',
    'patch-check',
    'check2-circle',
    'info-circle',
    'question-circle',
    'lightbulb',
    'graph-up',
    'bar-chart',
    'pie-chart',
    'speedometer2',
    'gear',
    'sliders',
    'palette',
    'image',
    'camera',
    'folder2-open',
    'bookmark-heart',
    'tag',
    'globe2',
];

function IconPickerField({ value, onChange, label = 'Choose icon' }) {
    const [open, setOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const filteredIcons = useMemo(() => {
        const query = searchQuery.trim().toLowerCase();
        if (!query) return SURVEY_ICONS;
        return SURVEY_ICONS.filter((icon) => icon.includes(query));
    }, [searchQuery]);

    const handleClose = () => {
        setOpen(false);
        setSearchQuery('');
    };

    const handleSelect = (icon) => {
        onChange(icon);
        handleClose();
    };

    return (
        <>
            <div className="ecx-survey-icon-picker">
                <button
                    type="button"
                    className="ecx-survey-icon-picker__trigger"
                    onClick={() => setOpen(true)}
                >
                    <span className="ecx-survey-icon-picker__value">
                        {value ? (
                            <>
                                <i className={`bi bi-${value}`} />
                                <span>{value}</span>
                            </>
                        ) : (
                            <span className="text-muted">{label}</span>
                        )}
                    </span>
                    <i className="bi bi-search text-muted" />
                </button>
                {value ? (
                    <button
                        type="button"
                        className="ecx-survey-icon-picker__clear"
                        title="Clear icon"
                        onClick={() => onChange('')}
                    >
                        <i className="bi bi-x-lg" />
                    </button>
                ) : null}
            </div>

            {open ? (
                <div
                    className="ecx-survey-modal-backdrop"
                    role="presentation"
                    onClick={handleClose}
                >
                    <div
                        className="ecx-survey-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-label="Select an icon"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <div className="ecx-survey-modal__header">
                            <div className="ecx-survey-modal__heading">
                                <h3 className="ecx-survey-modal__title">Select an icon</h3>
                                <p className="ecx-survey-modal__desc mb-0">
                                    {filteredIcons.length} of {SURVEY_ICONS.length} icons
                                </p>
                            </div>
                            <button
                                type="button"
                                className="ecx-survey-modal__close"
                                aria-label="Close"
                                onClick={handleClose}
                            >
                                <i className="bi bi-x-lg" />
                            </button>
                        </div>

                        <div className="ecx-survey-modal__body">
                            <div className="input-group input-group-sm mb-3">
                                <span className="input-group-text bg-white">
                                    <i className="bi bi-search text-muted" />
                                </span>
                                <input
                                    type="search"
                                    className="form-control"
                                    placeholder="Search icons…"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    autoFocus
                                />
                            </div>

                            <div className="ecx-survey-icon-picker__grid">
                                {filteredIcons.length ? (
                                    filteredIcons.map((icon) => (
                                        <button
                                            key={icon}
                                            type="button"
                                            title={icon}
                                            className={`ecx-survey-icon-picker__item${
                                                value === icon ? ' is-selected' : ''
                                            }`}
                                            onClick={() => handleSelect(icon)}
                                        >
                                            <i className={`bi bi-${icon}`} />
                                            <span>{icon}</span>
                                        </button>
                                    ))
                                ) : (
                                    <div className="ecx-survey-preview__empty w-100">
                                        No icons match “{searchQuery}”
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="ecx-survey-modal__footer">
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary rounded-pill"
                                onClick={handleClose}
                            >
                                <i className="bi bi-x-lg me-1" />
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
}

export default IconPickerField;
